import { render } from "./CompassDemo.vue?vue&type=template&id=2444d51c"
import script from "./CompassDemo.vue?vue&type=script&lang=js"
export * from "./CompassDemo.vue?vue&type=script&lang=js"

import "./CompassDemo.vue?vue&type=style&index=0&id=2444d51c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__